import React from "react";
import EmailBox from "./EmailBox";
import EmailField from "./EmailField";

const EmailsList = ({ label, list, addEmailsHandler, type, removeEmail,
   disabledAdding,defaultEmailText,placeholder,className }) => {
  return (
    <div className="emails__wrapper">
      {label && <div className="emails-label">{label}</div>}
      <div className={`emails__list ${className}`}>
        {defaultEmailText ? (
          <EmailBox  defaultEmailText={defaultEmailText} />
        ) : list?.map((item) => (
          <EmailBox key={item.email} {...item} removeEmail={removeEmail} />
        ))}
        {!disabledAdding && (
          <EmailField
          placeholder={placeholder}
            saveEmail={(email) => {
              addEmailsHandler({
                type,
                email,
              });
            }}
          />
        )}
      </div>
    </div>
  );
};

export default EmailsList;
